export default "__VITE_ASSET__5bd0d9df__$_?nuxt_component=async__"